/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Row,
  Checkbox,
  Table,
  Popconfirm,
  Select,
} from "antd";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import FilterContainer from "../../../components/common/FilterContainer";
import MultiSelect from "../../../components/common/MultiSelect";

import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import ConfirmationBox from "../../../components/common/ConfirmationBox";

import "./inspections.css";
import { inspections } from "./data";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import moment from "moment";
import { toast } from "react-hot-toast";

function Inspections() {
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(false);

  const handleUrl = () => {
    window.open("/inspection", "_blank");
  };

  const handleNewInspectionTemp = () => {
    window.open("/inspection/new_inspection_template", "_blank");
  };

  const InspectionsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        <span onClick={handleUrl}>New Inspection</span>,
        "1",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={handleNewInspectionTemp}>New Inspection Template</span>,
        "2",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={() => setIsConfirmationBoxOpen(true)}>
          Bulk Copy Inspection
        </span>,
        "3",
        "",
        "",
        ""
      ),
    ]),

    RightBarMethod(
      " HELP TOPICS",
      "t2",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("Create an Inspection Template", "6", "", "", "/")]
    ),
  ];

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [allProperties, setAllProperties] = useState([]);
  const [propertiesList, setPropertiesList] = useState([]);
  const [allInspections, setAllInspections] = useState([]);
  const [inspectionList, setInspectionList] = useState([]);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    setIsLoading(true)
    const fetchProperties = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspections");
        const snapshot = await getDocs(userRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
  
        const propertiesRef = collection(
          db,
          "companies",
          companyName,
          "properties"
        );
        const snapshotProperties = await getDocs(propertiesRef);
        const fetchedProperties = snapshotProperties.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
  
        const newData = fetchedData.map((item) => {
          // const matchedProperty = fetchedProperties.find(
          //   (property) => property.id === item.inspectionAddress
          // );

          const matchedProperty = fetchedProperties.find((dataItem) => {
            console.log('dataItem.id:', dataItem.id);
            console.log('item.inspectionAddress:', item.inspectionAddress);
            console.log('type of dataComparison:', typeof(dataItem.id));
            console.log('tyhpe of inspection:', typeof(item.inspectionAddress));
            return dataItem.id === item.inspectionAddress;
          });

          console.log("matchedProperty",matchedProperty)
          console.log("fetchedProperties",fetchedProperties)
          const propertyNameAddress = matchedProperty
            ? matchedProperty.propertyNameAddress
            : null;

          const flags =
            item.inspectionDetails && item.inspectionDetails.length > 0
              ? item.inspectionDetails.reduce((count, detail) => {
                  return (
                    count +
                    (detail.items
                      ? detail.items.filter((item) => item.isFollowUp).length
                      : 0)
                  );
                }, 0)
              : 0;
  
          return {
            key: item.id,
            date: item.inspectionDate,
            name: item.inspectionName,
            unitName: propertyNameAddress
              ? propertyNameAddress.propertyName
              : item.inspectionAddress,
            type: "Inspection",
            flags:
              flags > 0 ? (
                <p>
                  {flags}{" "}
                  <i className="fa-solid fa-flag" style={{ color: "red" }}></i>
                </p>
              ) : (
                0
              ),
          };
        });
  
        setAllInspections(fetchedData);
        setPropertiesList(fetchedProperties);
        setDataSource(newData);
        setInspectionList(
          fetchedData.map((item) => ({
            value: item.inspectionName,
            label: item.inspectionName,
          }))
        );
        setAllProperties(
          fetchedProperties.map((item) => ({
            value: item.id,
            label: item.propertyNameAddress.propertyName,
          }))
        );
      } catch (error) {
        console.error(error);
        alert(error.message);
      } finally{
      setIsLoading(false)
      }
    };
  
    fetchProperties();
  }, [companyName, isCompanyNameFetched]);
  
  const handleDelete = (key) => {
    const inspectionPath = `companies/${companyName}/inspections/${key}`;
    const inspectionDocRef = doc(db, inspectionPath);
    deleteDoc(inspectionDocRef)
      .then(() => {
        console.log("Inspection deleted successfully");
        toast.success("Inspection deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting inspection:", error);
        toast.error("Error deleting inspection",error);
      });
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const columns = [
    {
      key: "date",
      title: "Date",
      dataIndex: "date",
      sorter: true,
      width: "20%",
    },
    {
      key: "name",
      title: "Name",
      dataIndex: "name",
      sorter: true,
      width: "40%",
    },
    {
      title: "Unit Name",
      dataIndex: "unitName",
      key: "unitName",
      width: "25%",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "10%",
    },
    {
      title: "Flags",
      dataIndex: "flags",
      key: "flags",
      width: "10%",
    },
    {
      title: "Actions",
      dataIndex: "x",
      key: "x",
      className: "exclude-column",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <a
            style={{ color: "red" }}
            onClick={(e) => {
              e.stopPropagation(); // Prevents event propagation to the row
              handleDelete(record.key);
            }}
          >
            Delete
          </a>
        ) : null,
    },
  ];

  const handleClick = (record, rowIndex, event) => {
    // Perform action when row is clicked, excluding the specific column
    window.open(`/inspection/${record.key}`, "_blank");
  };
  const dateFormat = "YYYY-MM-DD";

  const onFinish = async (fieldsValue) => {
    const values = {
      ...fieldsValue,
      startDate: fieldsValue["startDate"]
        ? fieldsValue["startDate"].format(dateFormat)
        : null,
      endDate: fieldsValue["endDate"]
        ? fieldsValue["endDate"].format(dateFormat)
        : null,
    };

    const isEmptyFields = (fields) => {
      if (!fields) {
        return true;
      }

      for (const key in fields) {
        if (
          fields[key] !== null &&
          fields[key] !== undefined &&
          fields[key].length !== 0
        ) {
          return false;
        }
      }
      return true;
    };

    const result = isEmptyFields(values);

    const filteredData = allInspections.filter((item) => {
      const hasProperty =
        values.properties &&
        Array.isArray(values.properties) &&
        values.properties.includes(item.inspectionAddress);
      const hasUnit =
        values.units &&
        Array.isArray(values.units) &&
        values.units.includes(item.inspectionAddress);
      const hasInspection =
        values.inspectionName &&
        Array.isArray(values.inspectionName) &&
        values.inspectionName.includes(item.inspectionName);

      const isAfterStartDate =
        values.startDate &&
        moment(item.inspectionDate).isSameOrAfter(values.startDate, "day");
      const isBeforeEndDate =
        values.endDate &&
        moment(item.inspectionDate).isSameOrBefore(values.endDate, "day");

      return (
        hasProperty ||
        hasUnit ||
        hasInspection ||
        isAfterStartDate ||
        isBeforeEndDate
      );
    });

    const filtersEmpty = result ? allInspections : filteredData;
    const newData = filtersEmpty.map((item) => {
      const matchedProperty = propertiesList.find(
        (property) => property.id === item.inspectionAddress
      );
      const propertyNameAddress = matchedProperty
        ? matchedProperty.propertyNameAddress
        : null;

      const flags =
        item.inspectionDetails && item.inspectionDetails.length > 0
          ? item.inspectionDetails.reduce((count, detail) => {
              return (
                count +
                (detail.items
                  ? detail.items.filter((item) => item.isDone).length
                  : 0)
              );
            }, 0)
          : 0;
      return {
        key: item.id,
        date: item.inspectionDate,
        name: item.inspectionName,
        unitName: propertyNameAddress
          ? propertyNameAddress.propertyName
          : item.inspectionAddress,
        type: "Inspection",
        flags:
          flags > 0 ? (
            <p>
              {flags}{" "}
              <i className="fa-solid fa-flag" style={{ color: "red" }}></i>
            </p>
          ) : (
            0
          ),
      };
    });

    setDataSource(newData);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <div>
        <PageHeading heading="Inspections" />
        <FilterContainer heading="You can filter your inspections with the options below.">
          <Form
            name="basic"
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 16,
            }}
            autoComplete="off"
            colon={false}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={24}>
                <Form.Item label="Properties" name="properties">
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Search by property"
                    options={allProperties}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Units" name="units">
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Search by unit"
                    options={allProperties}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Inspection Name" name="inspectionName">
                  <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Search by inspection name"
                    options={inspectionList}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Date Range">
                  <Row align="middle">
                    <Col span={6}>
                      <Form.Item name="startDate">
                        <DatePicker
                          placeholder="Start date"
                          format={dateFormat}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <span>To</span>
                    </Col>
                    <Col span={6}>
                      <Form.Item name="endDate">
                        <DatePicker
                          placeholder="End date"
                          format={dateFormat}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label=" ">
                  <Checkbox>Only show inspection templates</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label=" ">
              <Button type="primary" htmlType="submit">
                Search
              </Button>
            </Form.Item>
          </Form>
        </FilterContainer>
        <Table
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          onChange={onChange}
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => {
                if (e.target.getAttribute("data-index") !== "x") {
                  handleClick(record, rowIndex);
                }
              },
            };
          }}
        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={InspectionsRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Copy Inspections</h2>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <p>
                Select which inspections to copy into a template. Templates can
                be used as a starting point for future inspections on web and
                mobile.
              </p>
            </Col>
            <Col span={24}>
              <Form layout="vertical">
                <Form.Item label="Inspections" required>
                  <MultiSelect
                    options={inspections}
                    placeholder="Search by Inspection, Occupancy, Property or Unit"
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <div className="action-buttons">
            <Button
              type="primary"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Copy
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default Inspections;
